import { LOCALES } from '../i18n'

export default {
    siteLang: localStorage.getItem('siteLang') || LOCALES.ARABIC,
    name: ''
}